console.log('DELI PREVIEW JS FINAL');

(function () {
  "use strict";

  function normalizeText(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/ı/g, "i")
      .replace(/ğ/g, "g")
      .replace(/ü/g, "u")
      .replace(/ş/g, "s")
      .replace(/ö/g, "o")
      .replace(/ç/g, "c");
  }

  function sanitize(url) {
    return String(url || "").trim();
  }

  function getPreviewData(productId) {
    return (window.DELI_PREVIEW_DATA || {})[String(productId)] || null;
  }

  function getColorKey(variant, previewData) {
    const aliases = (previewData && previewData.colorAliases) || {};
    const candidates = [];

    if (variant) {
      if (variant.option1) candidates.push(variant.option1);
      if (variant.option2) candidates.push(variant.option2);
      if (variant.option3) candidates.push(variant.option3);

      if (Array.isArray(variant.options)) {
        variant.options.forEach(function (optionValue) {
          candidates.push(optionValue);
        });
      }

      if (variant.title) candidates.push(variant.title);
      if (variant.public_title) candidates.push(variant.public_title);
      if (variant.name) candidates.push(variant.name);
    }

    for (let i = 0; i < candidates.length; i++) {
      let raw = normalizeText(candidates[i]);

      if (aliases[raw]) return aliases[raw];

      raw = raw.replace(/\s+/g, "-");

      if (aliases[raw]) return aliases[raw];

      if (raw.includes("rose")) return "rose-silver";
      if (raw.includes("gold")) return "gold-silver";
      if (raw.includes("dark")) return "dark-silver";
      if (raw.includes("light")) return "light-silver";

      if (
        raw === "dark-silver" ||
        raw === "light-silver" ||
        raw === "gold-silver" ||
        raw === "rose-silver"
      ) {
        return raw;
      }
    }

    return "light-silver";
  }

  function getBaseImage(previewData, colorKey, variant) {
    const config = (previewData && previewData.config) || {};
    const bases = config.emptyBaseImages || {};

    const selectedBase =
      bases[colorKey] && bases[colorKey].image
        ? sanitize(bases[colorKey].image)
        : "";

    const defaultBase =
      bases.default && bases.default.image
        ? sanitize(bases.default.image)
        : "";

    const variantFromData =
      previewData &&
      Array.isArray(previewData.variants) &&
      variant &&
      variant.id
        ? previewData.variants.find(function (v) {
            return String(v.id) === String(variant.id);
          })
        : null;

    const variantImage = sanitize(
      (variant && variant.previewImageMetafield) ||
      (variantFromData && variantFromData.previewImageMetafield) ||
      (variant && variant.featured_image && variant.featured_image.src) ||
      (variantFromData && variantFromData.featured_image && variantFromData.featured_image.src) ||
      (variant && variant.featuredImage) ||
      (variantFromData && variantFromData.featuredImage) ||
      (variant && variant.image) ||
      (variantFromData && variantFromData.image) ||
      ""
    );

    if (selectedBase && selectedBase !== defaultBase) return selectedBase;
    if (variantImage) return variantImage;
    if (selectedBase) return selectedBase;
    if (defaultBase) return defaultBase;

    return sanitize(
      (previewData && previewData.fallbackSelectedVariantImage) ||
      (previewData && previewData.fallbackProductImage) ||
      ""
    );
  }

  function limitChosenCharms(chosen, previewData) {
    const list = Array.isArray(chosen) ? chosen : [];
    const max = Number(previewData && previewData.charmLimit) || list.length || 0;

    if (!max || max < 1) return list;
    return list.slice(0, max);
  }

  function getCharmImage(item) {
    return sanitize(
      (item && item.img) ||
      (item && item.image) ||
      (item && item.previewImage) ||
      (item && item.preview_image) ||
      ""
    );
  }

  function getCharmTitle(item) {
    return String(
      (item && item.name) ||
      (item && item.title) ||
      ""
    );
  }

  function getCharmSku(item) {
    return String(
      (item && item.variantSku) ||
      (item && item.sku) ||
      ""
    );
  }

  function buildPayload(options) {
    const productId = options.productId;
    const variant = options.activeVariant;
    const chosen = options.chosen || [];

    const previewData = getPreviewData(productId);
    if (!previewData) return {};

    const limitedChosen = limitChosenCharms(chosen, previewData);
    const colorKey = getColorKey(variant, previewData);
    const baseImage = getBaseImage(previewData, colorKey, variant);

    const charms = limitedChosen
      .map(function (item) {
        return {
          image: getCharmImage(item),
          title: getCharmTitle(item),
          sku: getCharmSku(item)
        };
      })
      .filter(function (c) {
        return c.image;
      });

    const charmImages = charms.map(function (c) {
      return c.image;
    });

    const charmNames = charms
      .map(function (c) {
        return c.title;
      })
      .filter(Boolean);

    const payloadObject = {
      mode: "composite",
      productId: String(productId),
      colorKey: colorKey,
      baseImage: baseImage,
      charms: charms
    };

    const payload = {
      __deli_preview_base: baseImage,
      __deli_preview_chars: JSON.stringify(charmImages),
      __deli_preview_payload: JSON.stringify(payloadObject),

      __deli_preview_mode: "composite",
      __deli_preview_product_id: String(productId),
      __deli_preview_color_key: colorKey,
      __deli_preview_base_image: baseImage,
      __deli_preview_charm_count: String(charmImages.length),
      __deli_preview_charm_names: charmNames.join(" | "),
      __deli_preview_charm_images_json: JSON.stringify(charmImages)
    };

    charmImages.forEach(function (img, i) {
      payload["__deli_preview_charm_image_" + (i + 1)] = img;
    });

    return payload;
  }

  function read(properties) {
    if (!properties) {
      return { baseImage: "", charmImages: [] };
    }

    let data = properties.__deli_preview_payload || properties._deli_preview_payload;

    try {
      const parsed = JSON.parse(data);
      return {
        baseImage: parsed.baseImage || "",
        charmImages: (parsed.charms || [])
          .map(function (c) {
            return c.image;
          })
          .filter(Boolean)
      };
    } catch (e) {}

    let parsedCharmImages = [];
    try {
      parsedCharmImages = JSON.parse(
        properties.__deli_preview_chars ||
        properties._deli_preview_chars ||
        "[]"
      );
    } catch (e) {}

    return {
      baseImage:
        properties.__deli_preview_base ||
        properties.__deli_preview_base_image ||
        properties._deli_preview_base ||
        properties._deli_preview_base_image ||
        "",
      charmImages: parsedCharmImages
    };
  }

  window.DeliadorePreviewBuilder = {
    build: buildPayload,
    readProperties: read
  };
})();